import { render } from "./BoardModalInviteMember.vue?vue&type=template&id=32e52dc0&scoped=true"
import script from "./BoardModalInviteMember.vue?vue&type=script&lang=js"
export * from "./BoardModalInviteMember.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./BoardModalInviteMember.vue?vue&type=style&index=1&id=32e52dc0&scoped=true&lang=css"
import "./BoardModalInviteMember.vue?vue&type=style&index=2&id=32e52dc0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-32e52dc0"

export default script